<script>
import MyFolders from "./components/MyFolders.vue";
import RecentFiles from "./components/RecentFiles.vue";
import { piniaPlugin } from "../../../../stores";
import FormModal from "../../../../components/modals/FormModal.vue";
import MultiSelect from "vue-multiselect";

export default {
    components: { MyFolders, RecentFiles, FormModal, MultiSelect },
    props: {
        myFolders: {
            type: Array,
            default: () => [],
            required: true,
        },
        recentFiles: {
            type: Array,
            default: () => [],
            required: true,
        },
        folderTitle: {
            type: String,
            default: null,
            required: true,
        },
        fileTitle: {
            type: String,
            default: null,
            required: true,
        },
        folderType: {
            type: String,
            default: null,
            required: true,
        },
        fileType: {
            type: String,
            default: null,
            required: true,
        },
        noDataFolderTitle: {
            type: String,
            default: null,
            required: true,
        },
        noDataFileTitle: {
            type: String,
            default: null,
            required: true,
        },
        hasCurrentFolderPassword: {
            type: Boolean,
            default: false
        },
        selectedFolderId: {
            type: [Number, String]
        },
        showFolderContentFunc: {
            type: Function,
            default: (value) => {}
        },
        routeType: {
            type: String,
            default: null
        }
    },
    setup() {
        const store = piniaPlugin();
        return { store };
    },
    data() {
        return {
            fileIncrement: 12,
            folderIncrement: 12,
            perpage: 12,
            options: [12, 24, 36, 48],
            isFileDataLoading: false,
            isFolderDataLoading: false,
            isFileCount: 0,
            isFolderCount: 0
        }
    },
    computed: {
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        isData() {
            return this.store.useMultiSelect.showTopProgress;
        },
        isShowToast() {
            return this.store.useMultiSelect.toast.isToastMessage;
        },
        selectedItems() {
            return this.store.useMultiSelect.selectedItems.length > 0;
        } 
    },
    watch: {
        isData: function (value) {
            if (value) {
                this.$refs.topProgress.start();
            }
            else {
                this.$refs.topProgress.done();
            }
        },
        isShowToast: function (value) {
            if (value) {
                if (this.store.useMultiSelect.toast.isSuccess) {
                    this.$toastr.s(this.store.useMultiSelect.toast.successMsg);
                    this.store.useMultiSelect.resetOnComponentUpdate();
                }
                else {
                    this.$toastr.e(this.store.useMultiSelect.toast.successMsg);
                    setTimeout(() => {
                        this.store.useMultiSelect.toast.isToastMessage = false;
                    }, 2000);
                }
            }
        },
        selectedItems: function (value) {
            this.store.useMultiSelect.isShowActionButton = value;
        }
    },
    methods: {
        loadMore(type) {
            let i = 0;
            if(type == 'folders') {

                while(i < this.perpage) {
                    if(this.myFolders[this.folderIncrement] != undefined) {
                        this.folderIncrement++
                        i++
                    } else {
                        break
                    }
                }
                
                this.isFolderDataLoading = false
            }
            else {
                while(i < this.perpage) {
                    if(this.recentFiles[this.fileIncrement] != undefined) {
                        this.fileIncrement++
                        i++
                    } else {
                        break
                    }
                }

                this.isFileDataLoading = false
            }
        },
        adjustScrollableHeight(type = 'default') {
            let setHeightToAuto = document.querySelectorAll('.setListHeight')
            let folderIncrementValue = this.folderIncrement
            let fileIncrementValue = this.fileIncrement
            this.folderIncrement = this.perpage
            this.fileIncrement = this.perpage
            Array.from(setHeightToAuto).forEach((elem) => {
                elem.style.height = 'auto'
            });
            setTimeout(() => {
                let checkClassExist = document.querySelectorAll('.setListHeight')
                Array.from(checkClassExist).forEach((elem) => {
                    if(elem.classList.contains('scrollableBody')) {
                        if(elem.classList.contains('gridInfiniteData')) {
                            if(this.myFolders.length > this.folderIncrement) {
                                elem.style.height = (elem.firstChild.scrollHeight - 25) + "px" 
                            }
                            else {
                                elem.style.height = 'auto'
                            }
                        }
                        else {
                            if(this.recentFiles.length > this.fileIncrement) {
                                elem.style.height = (elem.firstChild.scrollHeight - 25) + "px" 
                            }
                            else {
                                elem.style.height = 'auto'
                            } 
                        }
                    }
                });
                if(type == 'setincrement') {
                    this.folderIncrement = folderIncrementValue
                    this.fileIncrement = fileIncrementValue
                }
            },400)
        },
        onMounted(action = 'default', type = 'default') {
            let self = this
            const fileElem = document.querySelectorAll('.listInfiniteData');
            const folderElem = document.querySelectorAll('.gridInfiniteData');

            if(action == 'delete') {
                if(type == 'folders') {
                    let folderIncrementValue = self.folderIncrement
                    self.folderIncrement = 0
                    self.loadMore(type)
                    self.folderIncrement = folderIncrementValue
                    if(self.myFolders.length < self.folderIncrement) {
                        let deletedFolders = self.folderIncrement - self.myFolders.length;
                        self.folderIncrement = self.folderIncrement - deletedFolders
                    }
                }
                else {
                    let fileIncrementValue = self.fileIncrement
                    self.fileIncrement = 0
                    self.loadMore(type)
                    self.fileIncrement = fileIncrementValue
                    if(self.recentFiles.length < self.fileIncrement) {
                        let deletedFiles = self.fileIncrement - self.recentFiles.length;
                        self.fileIncrement = self.fileIncrement - deletedFiles
                    }
                }
                self.adjustScrollableHeight('setincrement')
            }
            else if(action == 'add') {
                if(self.folderType == 'OwnContent' && self.fileType == 'OwnContent') {
                    let folderIncrementValue = self.folderIncrement
                    self.folderIncrement = 0
                    self.loadMore(type)
                    self.folderIncrement = folderIncrementValue
                    if(self.folderIncrement < self.myFolders.length) {
                        let addedFolders = self.myFolders.length - self.folderIncrement;
                        for(let i = 0; i < addedFolders; i++) {
                            if(self.folderIncrement % self.perpage != 0) {
                                self.folderIncrement++
                            }
                        }
                    }
                    
                }
                else {
                    if(type == 'folders') {
                        let folderIncrementValue = self.folderIncrement
                        self.folderIncrement = 0
                        self.loadMore(type)
                        self.folderIncrement = folderIncrementValue
                        if(self.folderIncrement < self.myFolders.length) {
                            let addedFolders = self.myFolders.length - self.folderIncrement;
                            for(let i = 0; i < addedFolders; i++) {
                                if(self.folderIncrement % self.perpage != 0) {
                                    self.folderIncrement++
                                }
                            }
                        }  
                    }
                    else {
                        let fileIncrementValue = self.fileIncrement
                        self.fileIncrement = 0
                        self.loadMore(type)
                        self.fileIncrement = fileIncrementValue
                        if(self.fileIncrement < self.recentFiles.length) {
                            let addedFiles = self.recentFiles.length - self.fileIncrement;
                            for(let i = 0; i < addedFiles; i++) {
                                if(self.fileIncrement % self.perpage != 0) {
                                    self.fileIncrement++
                                }
                            }
                        }
                    }
                }
                self.adjustScrollableHeight('setincrement')
            }
            else if(action == 'setincrement') {
                self.adjustScrollableHeight(action)
            }
            else if(action == 'search') {
                self.perpage = self.options[0]
                self.fileIncrement = self.perpage
                self.folderIncrement = self.perpage
                this.store.useMultiSelect.resetOnComponentUpdate();
            }
            else if(action == 'perpage') {
                let setScrollTop = document.querySelectorAll('.setListHeight')
                Array.from(setScrollTop).forEach((elem) => {
                    elem.scrollTop = 0
                });
                setTimeout(() => {
                    self.perpage = type
                    self.fileIncrement = type
                    self.folderIncrement = type
                    self.adjustScrollableHeight()
                },200);

            }

            Array.from(folderElem).forEach((listItemElem) => {
                listItemElem.addEventListener('scroll', function() {
                    if((listItemElem.scrollHeight - listItemElem.scrollTop)-3 <= listItemElem.clientHeight) {
                        

                        if(self.folderIncrement < self.myFolders.length) {
                            self.isFolderDataLoading = true
                        }

                        if(self.isFolderCount == 0) {
                            setTimeout(() => {
                                self.loadMore('folders')
                                self.isFolderCount = 0
                            },1000)
                        }
                        self.isFolderCount++
                    }
                })
            });

            Array.from(fileElem).forEach((listItemElem) => {
                listItemElem.addEventListener('scroll', function() {

                    if((listItemElem.scrollHeight - listItemElem.scrollTop)-3 <= listItemElem.clientHeight) {

                        if(self.fileIncrement < self.recentFiles.length) {
                            self.isFileDataLoading = true
                        }

                        if(self.isFileCount == 0) {
                            setTimeout(()=> {
                                self.loadMore('files')
                                self.isFileCount = 0
                            },1000)
                        }
                        self.isFileCount++
                    }
                })
            });
        }
    },
    mounted() {
        this.store.useMultiSelect.resetOnComponentUpdate();
    }
};
</script>

<template>
    <div class="position-relative">
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div class="card">
            <div class="card-body">
                <MyFolders 
                    :allItems="myFolders"
                    :folderTitle="folderTitle"
                    :folderType="folderType"
                    :noDataFolderTitle="noDataFolderTitle"
                    classes="folders"
                    :increment="folderIncrement"
                    :isDataLoading="isFolderDataLoading"
                    :onMounted="onMounted"
                    :perpage="perpage"
                    :options="options"
                    :hasCurrentFolderPassword="hasCurrentFolderPassword"
                    :selectedFolderId="selectedFolderId"
                    :showFolderContentFunc="showFolderContentFunc"
                    :routeType="routeType"
                />
                <div v-if="this.folderType !== 'OwnContent' && this.folderType !== 'SharedContent'" class="mt-4">
                    <RecentFiles 
                        :allItems="recentFiles"
                        :fileTitle="fileTitle"
                        :fileType="fileType"
                        :noDataFileTitle="noDataFileTitle"
                        classes="files"
                        :increment="fileIncrement"
                        :isDataLoading="isFileDataLoading"
                        :onMounted="onMounted"
                        :perpage="perpage"
                        :routeType="routeType"
                    />
                </div>
            </div>
        </div>
        <FormModal
            :isShow="store.useMoveStore.isShowMoveModal"
            title="Move folders and files"
            :isButtonLoading="store.useMoveStore.isButtonLoading"
            :isShowSubmitButton="true"
            :clickSubmitButton="() => store.useMoveStore.moveFolderFile(userTypeAbbr)"
            :submitButtonText="store.useMoveStore.submitButtonText"
            :isShowCancelButton="true"
            @hideModal="store.useMoveStore.hideMoveModal"
            :noClose="false"
        >   
            <div class="row">
                <div class="col-12">
                    <div v-if="store.useMoveStore.isFolderLoader" class="text-center">
                        <div class="spinner-border text-success m-3" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else class="mb-3">
                        <label>Choose a folder to which to move</label>
                        <MultiSelect
                            v-model="store.useMoveStore.selectedFolderId"
                            :options="store.useMoveStore.allFolderData" 
                            :custom-label="({name}) => name" 
                            placeholder="Please select a folder" 
                            label="moveFolderFile" 
                            track-by="name"
                        />
                        <div v-if="store.useMoveStore.errors.folderId" class="text-danger">
                            {{ store.useMoveStore.errors.folderId }}
                        </div>
                        <div v-if="store.useMoveStore.errors.message" class="text-danger" v-html="store.useMoveStore.errors.message"></div>
                    </div>
                </div>
            </div>
        </FormModal>
        <div v-if="store.useMoveStore.isCheckingValidation" class="position-fixed top-0 start-0 end-0 bottom-0 d-flex flex-column align-items-center justify-content-center backdrop">
            <div class="text-success fs-3 fw-bold mb-2">Checking All Validation...</div>
            <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .backdrop {
        background-color: rgba(0, 0, 0, 0.8); /* Backdrop color and opacity */
        z-index: 9999;
    }
</style>
